"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountEventData = exports.PageEventData = void 0;
var PageEventData = (function () {
    function PageEventData($http, apiBaseUrl, scope) {
        this.$http = $http;
        this.scope = scope;
        this.apiBaseUrl = apiBaseUrl;
        this.responsePromise = this.retrieveEventData(this.getTimezone(), this.scope.projectId, this.scope.viewId);
    }
    PageEventData.prototype.getDailyViewCounts = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.responsePromise];
                    case 1:
                        response = _a.sent();
                        return [2, {
                                result: response.data.viewCounts,
                            }];
                }
            });
        });
    };
    PageEventData.prototype.getRecentViews = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.responsePromise];
                    case 1:
                        response = _a.sent();
                        return [2, response.data.recentViews];
                }
            });
        });
    };
    PageEventData.prototype.getTimezone = function () {
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return timezone;
    };
    PageEventData.prototype.getSummaryAnalytics = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.responsePromise];
                    case 1:
                        response = _a.sent();
                        return [2, response.data.overview];
                }
            });
        });
    };
    PageEventData.prototype.getLinkClicks = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.responsePromise];
                    case 1:
                        response = _a.sent();
                        return [2, response.data.linkClicks];
                }
            });
        });
    };
    PageEventData.prototype.getAverageBlockViewDurations = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.responsePromise];
                    case 1:
                        response = _a.sent();
                        return [2, response.data.blockViewDurations];
                }
            });
        });
    };
    PageEventData.prototype.getTotalBlockViewDurations = function (groupViews) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.responsePromise];
                    case 1:
                        response = _a.sent();
                        return [2, response.data.blockViewDurations];
                }
            });
        });
    };
    PageEventData.prototype.retrieveEventData = function (timezone, pageId, viewId) {
        if (this.responsePromise) {
            return this.responsePromise;
        }
        else if (pageId && viewId) {
            return this.retrieveIndividualViewDetailMetrics(pageId, viewId);
        }
        else if (pageId) {
            return this.retrievePageAnalyticsSummaryMetrics(pageId, timezone);
        }
        throw new Error("Bad request");
    };
    PageEventData.prototype.retrievePageAnalyticsSummaryMetrics = function (pageId, timezone) {
        return this.$http.get("".concat(this.apiBaseUrl, "/dataset/pages/").concat(pageId, "?timezone=").concat(encodeURIComponent(timezone)));
    };
    PageEventData.prototype.retrieveIndividualViewDetailMetrics = function (pageId, viewId) {
        return this.$http.get("".concat(this.apiBaseUrl, "/dataset/pages/").concat(pageId, "/views/").concat(viewId));
    };
    return PageEventData;
}());
exports.PageEventData = PageEventData;
var AccountEventData = (function () {
    function AccountEventData($http, apiBaseUrl) {
        this.$http = $http;
        this.apiBaseUrl = apiBaseUrl;
    }
    AccountEventData.prototype.getDailyViewCounts = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.$http.get("".concat(this.apiBaseUrl, "/dataset/pages"))];
                    case 1:
                        response = _a.sent();
                        return [2, response.data];
                }
            });
        });
    };
    return AccountEventData;
}());
exports.AccountEventData = AccountEventData;
